/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppMessageByTemplateTokenRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {GetAppMessageByTemplateTokenResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const getAppMessageByTemplateToken = (request: GetAppMessageByTemplateTokenRequest, options?: CashRequestOptions) => post<GetAppMessageByTemplateTokenRequest, GetAppMessageByTemplateTokenResponse>("/2.0/cash/get-app-message-by-template-token", request, {...options, rejectOnError: true })